module.exports = __webpack_public_path__ + "static/media/abstract3.2462ce56.jpg";